export function convertStringToValidId(str) {
    return str
        .toLowerCase() // Convert to lowercase
        .trim() // Remove whitespace from both ends
        .normalize("NFD") // Normalize the string (decompose combined characters into individual ones)
        .replace(/[\u0300-\u036f]/g, "") // Remove diacritical marks
        .replace(/[^a-z0-9\s-]/g, "") // Remove special characters except hyphens and spaces
        .replace(/\s+/g, '-') // Replace spaces with hyphens
        .replace(/^-+|-+$/g, ""); // Remove any leading or trailing hyphens
}